module.exports = __webpack_public_path__ + "img/home.c0d958c4.png";